<template>
  <v-container fluid grid-list-sm>
    <v-card>
      <v-toolbar flat>
        <v-toolbar-title>
          <span class="font-weight-medium">
            {{ $t('ITEM.CREATE') }} {{ $t('BUILDING_COMPLEXES.ITEM') }}
          </span>
        </v-toolbar-title>
        <v-spacer />
        <v-btn dark color="indigo" @click="$router.push({ name: 'building_complexes' })">
          {{ $t('BUTTON.BACK') }}
        </v-btn>
      </v-toolbar>
      <v-divider></v-divider>
    </v-card>
    <v-card class="mt-3" tile :loading="loading">
      <v-card-text>
        <v-form v-model="valid">
          <building-complex-form
            v-model="form"
            :errors="errors.getAll()"
            @update-prop="clearErrorByName($event)"
          >
          </building-complex-form>
        </v-form>
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn
          depressed
          type="submit"
          :disabled="!valid"
          large
          color="primary"
          @click.prevent="createBuildingComplex"
        >
          {{ $t('BUTTON.SAVE') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-container>
</template>

<script>
import errors from '@/modules/_global/mixins/errors';
import { mapGetters } from 'vuex';
import BuildingComplexForm from '@/modules/building_complexes/components/forms/BuildingComplexForm';
import { BuildingComplexesService } from '@/services/building-complexes.service';

export default {
  name: 'CompanyCreatePage',

  components: { BuildingComplexForm },

  mixins: [errors],

  data() {
    return {
      form: {},
      valid: false
    };
  },

  computed: {
    ...mapGetters(['loading'])
  },

  methods: {
    createBuildingComplex() {
      BuildingComplexesService.create(this.form)
        .then(({ data }) => {
          this.$store.commit('snackbar/setSnack', {
            status: 'success',
            text: this.$t('MESSAGE.SUCCESS')
          });
          this.$router.push({ name: 'building_complexes' });
        })
        .catch(this.handleErrors);
    }
  }
};
</script>

<style scoped></style>
